module.exports = __webpack_public_path__ + "static/img/GBZ905-FCM-399-BB-2.fb21711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GBZ905-FCM-399-BB-2.jpg
// module id = zW5k
// module chunks = 0